import { Component, inject } from '@angular/core';
import {
  FormControl,
  FormGroup,
  Validators,
  FormsModule,
  ReactiveFormsModule,
} from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';
import { InvitationService } from '@core/services/invitation.service';
import { authMessages } from '@workers';
import {
  MatCard,
  MatCardHeader,
  MatCardTitle,
  MatCardContent,
  MatCardActions,
  MatCardFooter,
} from '@angular/material/card';
import { MatDivider } from '@angular/material/divider';
import {
  MatFormField,
  MatLabel,
  MatSuffix,
  MatError,
} from '@angular/material/form-field';
import { MatInput } from '@angular/material/input';
import { MatIcon } from '@angular/material/icon';

import { MatButton } from '@angular/material/button';
import { MatProgressBar } from '@angular/material/progress-bar';

@Component({
  selector: 'app-link-user-to-compagny-modal',
  templateUrl: './link-user-to-compagny-modal.component.html',
  styleUrls: ['./link-user-to-compagny-modal.component.scss'],
  imports: [
    MatCard,
    MatCardHeader,
    MatCardTitle,
    MatDivider,
    MatCardContent,
    FormsModule,
    ReactiveFormsModule,
    MatFormField,
    MatLabel,
    MatInput,
    MatIcon,
    MatSuffix,
    MatError,
    MatCardActions,
    MatButton,
    MatCardFooter,
    MatProgressBar,
  ],
})
export class LinkUserToCompagnyModalComponent {
  private readonly invitationService = inject(InvitationService);

  private readonly dialogRef = inject(MatDialogRef);

  protected authMsg = authMessages;

  protected form = new FormGroup({
    email: new FormControl('', [Validators.required, Validators.email]),
    firstName: new FormControl('', [Validators.required]),
    lastName: new FormControl('', [Validators.required]),
  });

  get email() {
    return this.form.controls.email;
  }

  get firstName() {
    return this.form.controls.firstName;
  }

  get lastName() {
    return this.form.controls.lastName;
  }

  protected formInProgress: boolean = false;

  submit(): void {
    const bodyData = this.form.getRawValue() as {
      email: string;
      lastName: string;
      firstName: string;
    };
    this.invitationService.create(bodyData).subscribe(() => {
      this.dialogRef.close();
    });
  }

  cancel(): void {
    this.dialogRef.close();
  }
}
